import { Autocomplete, Box, Button, Container, Stack, TextField, Typography } from '@mui/material';
import { Formik } from 'formik';
import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import * as Yup from 'yup';
import toast from 'react-hot-toast';
import Loading from '../../components/Loading';
import { useGetAllParkingSpaceLocationMutation } from '../../store/api/parkingsApi';
import { useSaveDeviceDataMutation, useUpdateDeviceDataMutation } from '../../store/api/posDeviceApi';



type Props = {};

const customerSchema = Yup.object().shape({
    deviceName: Yup.string().required('please enter device name'),
    deviceId: Yup.string().required('Please enter device id ')
});

const ResponsiveBox = styled('div')(({ theme }) => ({
    padding: theme.spacing(1),
    [theme.breakpoints.down('md')]: {
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
    },
    [theme.breakpoints.up('md')]: {
        flexDirection: 'row',
    },
}));

const FormikBox = styled('div')(({ theme }) => ({
    padding: theme.spacing(1),
    [theme.breakpoints.down('md')]: {
        marginLeft: '0px',
    },
    [theme.breakpoints.up('md')]: {
        marginLeft: '20px',
    },
}));

const AddOrUpdatePosDevice = (props: Props) => {
    const { state }: any = useLocation();
    const [value, setValue] = useState(null);
    console.log(value, "value");
    const [getAllParkingSpaceLocation, response] = useGetAllParkingSpaceLocationMutation();
    const [updateDeviceData, updateDeviceDataResponse] = useUpdateDeviceDataMutation()
    const [saveDeviceData, saveDeviceDataResponse] = useSaveDeviceDataMutation()
    const navigate = useNavigate();
    const [initialValues, setInitialValues] = useState({
        deviceId: '',
        parkingName: '',
        deviceName: '',

    });
    const [selectedOptions, setSelectedOptions] = useState() as any;
    const [serviceProviders, setServiceProviders] = useState<any>([]);
    const token = JSON.parse(localStorage.getItem('login') || '{}').token;
    console.log(selectedOptions, "selectedOptions");
    const [editServiceProvider, setEditServiceProvider] = useState() as any;



    const selectItems = (option: any) => {
        console.log(option, "option");
        if (option !== null && option !== undefined) {
            setSelectedOptions(option);
        }
    };


    function getSelectedItem() {
        const item =
            editServiceProvider &&
            editServiceProvider?.find((opt: any) => {
                return opt;
            });
        if (item !== null && item !== undefined) {
            selectItems(item);
        }
        return item || null;

    }


    const selectServiceProvider = (event: any) => {
        getAllParkingSpaceLocation({
            token: token,
            payload: {
                columnName: 'id',
                offset: 100,
                page: 0,
                orderBy: 'desc',
                name: event,
                serviceProviderId: token.serviceProviderId,
                currentStage: 'active',
            },
        });
    };

    useEffect(() => {
        getAllParkingSpaceLocation({
            token: token,
            payload: {
                columnName: 'id',
                offset: 100,
                page: 0,
                orderBy: 'desc',
                serviceProviderId: token.serviceProviderId,
                currentStage: 'active',
            },
        });

    }, [])



    useEffect(() => {
        if (response.isSuccess) {
            setServiceProviders([response?.data?.data]);
            console.log(response?.data?.data, "response?.data?.data");
            if (state.editMode) {
                setEditServiceProvider(response?.data?.data)
            }

        }
    }, [response.isSuccess]);



    const handleAddOrUpdatePosDevice = (values: any) => {
        if (!state.editMode) {
            saveDeviceData({
                token: token,
                payload: {
                    deviceId: values.deviceId,
                    parkingLocationId: selectedOptions?.id,
                    parkingName: selectedOptions?.name,
                    name: values.deviceName,
                    status: true
                },
            });
        } else {
            updateDeviceData({
                token: token,
                payload: {
                    id: state.editData.id,
                    deviceId: values.deviceId,
                    parkingLocationId: selectedOptions?.id,
                    parkingName: selectedOptions?.name,
                    name: values.deviceName,
                    status: true
                },
            });
        }
    };

    useEffect(() => {
        if (state.editData) {
            setInitialValues({
                deviceId: state.editData.deviceId,
                parkingName: state.editData.parkingName,
                deviceName: state.editData.name
            });
            selectServiceProvider(state.editData.parkingName)
        }

    }, []);

    useEffect(() => {
        if (saveDeviceDataResponse.isSuccess) {
            toast.success('Pos Device added successfully');
            navigate('/dashboard/pos-device', { replace: true });
        } else if (saveDeviceDataResponse.isError) {
            let errorData: any = saveDeviceDataResponse.error;
            let msg: any = errorData?.data?.serviceErrors[0]?.msg;
            toast.error('Something went wrong ' + msg || '');
        }

        if (updateDeviceDataResponse.isSuccess) {
            toast.success('Pos Device updated successfully');
            navigate('/dashboard/pos-device', { replace: true });
        } else if (updateDeviceDataResponse.isError) {
            let errorData: any = updateDeviceDataResponse.error;
            let msg: any = errorData?.data?.serviceErrors[0]?.msg;
            toast.error('Something went wrong ' + msg || '');
        }
    }, [
        saveDeviceDataResponse.isSuccess,
        saveDeviceDataResponse.isError,
        updateDeviceDataResponse.isSuccess,
        updateDeviceDataResponse.isError,
    ]);


    const validate = (values: any) => {
        console.log(values)
        const errors: any = {};

        if (value == null) errors['parkingName'] = 'This field is required';
        return errors;
    };

    return (
        <Box>
            <Container>
                <h1>{state.editMode ? 'Edit Pos Device' : 'Add Pos Device'}</h1>
                <ResponsiveBox style={{ display: 'flex', paddingTop: '40px' }}>
                    <FormikBox style={{ flex: 1, padding: 0 }}>
                        <Formik
                            enableReinitialize
                            initialValues={initialValues}
                            onSubmit={handleAddOrUpdatePosDevice}
                            validationSchema={customerSchema}
                            validate={validate}
                        >
                            {({ handleBlur, handleChange, handleSubmit, values, touched, errors }) => (
                                <Box>


                                    <Box width={'100%'}>
                                        <Stack direction="column" alignItems="self-start">
                                            <Typography variant="h5" gutterBottom component="div">
                                                Device Id
                                            </Typography>
                                            <TextField
                                                fullWidth
                                                autoComplete="deviceId"
                                                sx={{ width: '100%' }}
                                                type="text"
                                                name="deviceId"
                                                label="Enter Device Id"
                                                value={values.deviceId}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                error={Boolean(touched.deviceId && errors.deviceId)}
                                                helperText={touched.deviceId && errors.deviceId}
                                            />
                                        </Stack>
                                    </Box>

                                    <Box style={{ width: '100%' }}>
                                        <Typography variant="h5" marginTop={2} marginBottom={1} gutterBottom component="div">
                                            Parking Name
                                        </Typography>
                                        <Autocomplete
                                            id="parkingName"
                                            value={selectedOptions? selectedOptions : getSelectedItem()}
                                            options={serviceProviders[0]}
                                            getOptionLabel={(item: any) => (item?.name ? `${item?.name}` : '')}
                                            style={{ width: '100%' }}
                                            renderInput={(params) => <TextField {...params} label="Parking Name" variant="outlined" required />}
                                            onChange={(event: any, value: any) => {
                                                if (value !== null && value !== '') {
                                                    selectItems(value);
                                                }
                                            }}
                                            onInputChange={(event: any, value: any) => {
                                                setValue(value);
                                                if (value !== null && value !== '' && value.length >= 4) {
                                                    selectServiceProvider(value);
                                                }
                                            }}
                                            clearOnBlur={true}
                                            clearOnEscape={true}
                                        />
                                        {errors.parkingName && <div style={{ color: 'red' }}>{errors.parkingName}</div>}
                                    </Box>
                                    <Box width={'100%'}>
                                        <Stack direction="column" alignItems="self-start">
                                            <Typography variant="h5" gutterBottom component="div">
                                                Device Name
                                            </Typography>
                                            <TextField
                                                fullWidth
                                                autoComplete="deviceName"
                                                sx={{ width: '100%' }}
                                                type="text"
                                                name="deviceName"
                                                label="Enter Device Name"
                                                value={values.deviceName}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                error={Boolean(touched.deviceName && errors.deviceName)}
                                                helperText={touched.deviceName && errors.deviceName}
                                            />
                                        </Stack>
                                    </Box>




                                    <Box style={{ width: '100%', display: 'flex', marginLeft: '75%', marginTop: '20px' }}>
                                        <Button
                                            style={{
                                                color: 'white',
                                                backgroundColor: '#E23744',
                                            }}
                                            variant="contained"
                                            color="error"
                                            onClick={() => {
                                                navigate('/dashboard/pos-device');
                                            }}
                                            sx={{ marginRight: '10px' }}
                                            size="large"
                                        >
                                            Cancel
                                        </Button>
                                        <Button
                                            style={{
                                                color: 'white',
                                                backgroundColor: '#E23744',
                                            }}
                                            variant="contained"
                                            onClick={() => {
                                                handleSubmit();
                                            }}
                                            size="large"
                                            type="submit"
                                        >
                                            {state.editMode ? 'Update' : 'Add'}
                                        </Button>
                                    </Box>
                                </Box>
                            )}
                        </Formik>
                    </FormikBox>
                </ResponsiveBox>
            </Container>
            {updateDeviceDataResponse.isLoading || saveDeviceDataResponse.isLoading ? <Loading /> : null}
        </Box>
    );
};

export default AddOrUpdatePosDevice;
